// extracted by mini-css-extract-plugin
export var buttonContent = "_41-0";
export var centered = "_41-1";
export var centeredFlex = "_41-2";
export var errorText = "_41-3";
export var icon = "_41-4";
export var iconButtonContent = "_41-5";
export var monospace = "_41-6";
export var padded = "_41-7";